import {
  defaultSelectStyles,
  inlineObjectFieldStyles,
} from 'components/DataEntry';

import { customTheme } from '../../../../../../theme';

export const addConditionButtonStyles = {
  border: '1px solid',
  borderColor: customTheme.colors.gray['200'],
  color: 'primary',
  px: 1,
  py: 1,
  cursor: 'pointer',
  borderRadius: 6,
  fontSize: '15px',
  bg: 'white',
  height: 'auto',
  maxH: 8,
};

export const conditionsSelectorStyles = {
  select: {
    control: (styles, props) => ({
      ...defaultSelectStyles().control(styles, props),
      backgroundColor: 'white',
      borderRadius: '6px',
    }),
    valueContainer: (styles, props) => ({
      ...defaultSelectStyles().valueContainer(styles, props),
      borderRadius: '6px',
    }),
  },
};

export const snowflakeConditionGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) repeat(2, 20px)',
  gap: 2,
  alignItems: 'center',
};

export const dataPolicyFormStyles = {
  form: {
    formWidth: '750px',
    helpComponent: { borderLeft: 'none' },
    submitButton: { tooltipStyles: { color: 'red' } },
    title: { labelStyles: { w: 'full' } },
  },
  objectField: { ...inlineObjectFieldStyles },
};
